import { Link } from "react-router-dom";
import { Mail, QrCode, CreditCard } from "lucide-react";
import { SUPPORT_EMAIL } from "@/lib/support";

export const PayMethods = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-3 text-xs text-muted-foreground ${className}`} data-testid="pay-methods-badge">
    <span className="inline-flex items-center gap-1"><QrCode className="h-3.5 w-3.5 text-[#32BCAD]" />Pix</span>
    <span className="inline-flex items-center gap-1"><CreditCard className="h-3.5 w-3.5" />Cartão</span>
  </span>
);

export default function SiteFooter() {
  return (
    <footer className="border-t py-6 px-5 text-xs text-muted-foreground" data-testid="site-footer">
      <div className="max-w-6xl mx-auto flex flex-wrap gap-x-5 gap-y-3 items-center">
        <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-1.5 whitespace-nowrap hover:text-foreground transition-colors" data-testid="footer-support-email">
          <Mail className="h-3.5 w-3.5" />Suporte: {SUPPORT_EMAIL}</a>
        <span className="inline-flex items-center gap-2 whitespace-nowrap">Pagamento via Mercado Pago: <PayMethods /></span>
        <Link to="/privacidade" className="whitespace-nowrap hover:text-foreground transition-colors" data-testid="footer-privacy-link">Privacidade</Link>
        <Link to="/termos" className="whitespace-nowrap hover:text-foreground transition-colors" data-testid="footer-terms-link">Termos de Uso</Link>
        <span className="w-full lg:w-auto lg:ml-auto">© {new Date().getFullYear()} Cem Zebra Ai. Google Ads é marca registrada do Google LLC. Produto independente, sem afiliação ao Google.</span>
      </div>
    </footer>
  );
}
